export function useAuth() {
  const { isProfessionalStore } = useStore();
  const { locale } = useI18n();
  const { refreshSessionContext } = useSessionContext();
  const { refreshCart } = useCart();
  const { getLocalizedPaths } = useRoutePaths();

  const paths = getLocalizedPaths(locale.value);

  const successAfterLogin = async (path = '') => {
    if (path === '') {
      path = isProfessionalStore ? paths.home : paths.account;
    }
    await refreshSessionContext();
    await navigateTo(path, { replace: true });
    refreshCart();
  };

  const successAfterLogout = async (path = '') => {
    if (path === '') {
      path = paths.login;
    }
    await refreshSessionContext();
    await navigateTo(path, { external: true });
  };

  return {
    successAfterLogin,
    successAfterLogout,
  };
}
